/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { SignedUrl, SignedUrlAction, SignedUrlTypes } from './type';

export interface SignedUrlState {
  signedUrls: SignedUrl[];
  formats: string[];
  prefix: string;
  loading: boolean;
  error: Error;
}

export const initialSignedUrlState: SignedUrlState = {
  signedUrls: [],
  formats: [],
  prefix: '',
  loading: false,
  error: null,
};

export function signedUrlReducer(state = initialSignedUrlState, action: SignedUrlAction) {
  switch (action.type) {
    case SignedUrlTypes.SIGNED_URLS_REQUEST:
      return update(state, {
        formats: { $set: action.input.formats },
        prefix: { $set: action.input.prefix },
        loading: { $set: true },
      });
    case SignedUrlTypes.SIGNED_URLS_SUCCESS:
      return update(state, {
        signedUrls: { $set: action.signedUrls },
        loading: { $set: false },
      });
    case SignedUrlTypes.SIGNED_URLS_ERROR:
      return update(state, {
        error: { $set: action.error },
        loading: { $set: false },
      });
    case SignedUrlTypes.RESET_SIGNED_URLS_ERROR:
      return update(state, {
        error: { $set: null },
      });
    case SignedUrlTypes.RESET_SIGNED_URLS:
      return initialSignedUrlState;
    default:
      return state;
  }
}
